import { PlayerOrNoneGameStateWithTable } from '../../jscaip/state/PlayerOrNoneGameStateWithTable';
export class ConnectSixState extends PlayerOrNoneGameStateWithTable {
}
